import { Button, Text } from "@chakra-ui/react";
import api from "api/api";
import apiWhatsApp from "api/api-whatsapp";
import { CustomModal } from "components/custom-modal";
import {
  CustomTableColor,
  CustomTableColorColumn,
} from "components/dynamic-table/color-table";
import { Toast } from "components/toast";
import { CloseIcon } from "components/vectors/close-icon";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { useState } from "react";

interface ModalParams {
  uuid: string;
}

interface HistoryProps {
  time: string;
  log: string;
  logTratado: string;
}

const eventName = "openModalHistoricoSessaoWpp";

export function ModalHistoricoSessaoWpp() {
  const [historyList, setHistoryList] = useState<HistoryProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onClose, params } = useModalControls<ModalParams>(eventName, {
    onOpen: (params) => {
      if (params?.uuid) {
        getData(params.uuid);
      }
    },
    onClose: () => {
      setHistoryList([]);
    },
  });

  const getData = async (uuid = params.uuid) => {
    setIsLoading(true);
    try {
      const { data } = await apiWhatsApp.get(`/api/wpphistory/${uuid}`);
      setHistoryList(data);
    } catch (e) {
      Toast({ title: "Erro ao obter histórico" });
    } finally {
      setIsLoading(false);
    }
  };

  const columns: CustomTableColorColumn<HistoryProps>[] = [
    {
      name: "Data",
      render: (row) => {
        return <>{row.time}</>;
      },
    },
    {
      name: "Log",
      render: (row) => {
        const isJson = row.log?.indexOf("{") === 0;
        if (isJson)
          return (
            <Text whiteSpace="pre-wrap">
              {JSON.stringify(JSON.parse(row.log))
                .replace(/:/g, ": ")
                .replace(/,/g, ", ")}
            </Text>
          );
        return <>{row.logTratado ?? row.log}</>;
      },
    },
  ];

  const modalFooter = (
    <>
      <Button leftIcon={<CloseIcon />} variant="outline" onClick={onClose}>
        Cancelar
      </Button>
    </>
  );

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Histórico Sessão WhatsApp"
      modalFooter={modalFooter}
      size="6xl"
      scroll="inside"
    >
      <CustomTableColor
        columns={columns}
        rows={historyList}
        isLoading={isLoading}
        loadingRowsCount={5}
        pageSize={historyList.length}
        emptyMessage="Não há histórico"
        showControls={false}
      />
    </CustomModal>
  );
}

export const openModalHistoricoSessaoWpp =
  createModalTrigger<ModalParams>(eventName);
